<app-go-application-buttons [navItems]="navItems"></app-go-application-buttons>
